/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Availabledates_Wednesday_May_1313Inputs */

const en__field__enum_availabledates_wednesday_may_1313 = /** @type {(inputs: _Field__Enum_Availabledates_Wednesday_May_1313Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wednesday, May 13, 2026`)
};

const de__field__enum_availabledates_wednesday_may_1313 = /** @type {(inputs: _Field__Enum_Availabledates_Wednesday_May_1313Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittwoch, 13.05.2026`)
};

/**
* | output |
* | --- |
* | "Wednesday, May 13, 2026" |
*
* @param {_Field__Enum_Availabledates_Wednesday_May_1313Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_availabledates_wednesday_may_1313 = /** @type {((inputs?: _Field__Enum_Availabledates_Wednesday_May_1313Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Availabledates_Wednesday_May_1313Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_availabledates_wednesday_may_1313(inputs)
	return de__field__enum_availabledates_wednesday_may_1313(inputs)
});
export { _field__enum_availabledates_wednesday_may_1313 as "_field__enum_availableDates_WEDNESDAY_MAY_13" }